"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const history_1 = require("history");
// make _history accessible for cypress
const history = (window['$$history'] = (0, history_1.createBrowserHistory)());
exports.default = history;
//# sourceMappingURL=dom-history.js.map